<template>
  <div class="bow-form-row">
    <slot></slot>
  </div>
</template>

<script>
  export default {}
</script>

<style scoped lang="less">
@import '../../assets/less/globals';

.bow-form-row {
  padding-top: var(--margin--small);
  padding-bottom: var(--margin--small);
  display: flex;
  flex-direction: column;
  min-width: 90vw;
  text-align: left;
}

label {
 display: block;
 float: left;
 margin-bottom: var(--margin--small);
 margin-top: var(--margin--small);
 font-size: 110%;
 min-width: 25%;
}


@media screen and (min-width: @screen-desktop-low) {
  .bow-form-row {
    min-width: 450px;
  }
}

@media screen and (min-width: @screen-desktop-large) {
  .bow-form-row {
    min-width: 600px;
  }
}
</style>
